import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { AttachmentModel } from '../model';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: AttachmentModel[] };

const initialState: State = { state: 'idle' };

@Injectable()
export class AttachmentStore extends ComponentStore<State> {
  readonly setAttachmentData = this.updater<AttachmentModel[]>((_, data) => ({
    state: 'valid',
    data: data,
  }));
  readonly selectData$ = this.select(s => (s.state === 'valid' ? s : null));

  constructor() {
    super(initialState);
  }
}
